if (!customElements.get('dnaskate-delivery-estimate')) {
  customElements.define('dnaskate-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.querySelector('[data-delivery-variants]').textContent);
      } catch (_) {
        this.variants = [];
      }
      this.section = this.closest('.shopify-section') || document;
      this.onChange = () => window.setTimeout(() => this.updateFromForm(), 80);
      this.section.addEventListener('change', this.onChange);
      this.update(this.dataset.selectedVariant);
      this.makeLocalWarehouseVariantsAvailable();
    }

    makeLocalWarehouseVariantsAvailable() {
      const europe = ['AT','BE','BG','HR','CZ','DK','EE','FI','FR','GR','ES','NL','IE','LT','LU','LV','DE','PT','RO','SK','SI','SE','HU','IT','RU'];
      const country = this.dataset.country;
      const localVariants = this.variants.filter(variant => {
        if (country === 'US') return variant.usLocal === true;
        if (europe.includes(country)) return variant.euLocal === true;
        return false;
      });
      if (localVariants.length === 0) return;

      const release = () => {
        const form = this.section.querySelector('form[action*="/cart/add"]');
        const idInput = form?.querySelector('[name="id"]');
        const submit = form?.querySelector('[type="submit"]');
        const selectedVariant = localVariants.find(variant => String(variant.id) === String(idInput?.value || this.dataset.selectedVariant));

        for (const variant of localVariants) {
          const option = [...this.section.querySelectorAll('input[type="radio"]')]
            .find(input => input.value === variant.title);
          if (option) {
            option.classList.remove('disabled');
            option.removeAttribute('disabled');
            option.removeAttribute('aria-disabled');
            option.closest('label')?.classList.remove('disabled');
            option.closest('.product-form__input, fieldset')?.classList.remove('disabled');
          }
        }

        if (!selectedVariant) return;
        if (idInput) {
          idInput.value = selectedVariant.id;
          idInput.disabled = false;
        }
        if (submit) {
          submit.disabled = false;
          submit.classList.remove('disabled');
          const label = submit.querySelector('span');
          if (label) label.textContent = document.documentElement.lang?.startsWith('zh') ? '加入購物車' : 'Add to cart';
        }
        this.section.querySelectorAll('.price--sold-out').forEach(price => price.classList.remove('price--sold-out'));
      };

      release();
      this.availabilityObserver = new MutationObserver(release);
      this.availabilityObserver.observe(this.section, { subtree: true, attributes: true, attributeFilter: ['class', 'disabled', 'checked'] });
      this.section.addEventListener('change', release, true);
    }

    disconnectedCallback() {
      this.section?.removeEventListener('change', this.onChange);
      this.availabilityObserver?.disconnect();
    }

    updateFromForm() {
      const input = this.section.querySelector('form[action*="/cart/add"] [name="id"]');
      this.update(input?.value || this.dataset.selectedVariant);
    }

    dateRange(daysText) {
      const values = String(daysText || '').match(/\d+/g)?.map(Number) || [];
      const minimum = values[0] || 7;
      const maximum = values[1] || minimum;
      const format = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month: 'short', day: 'numeric' });
      const start = new Date();
      const end = new Date();
      start.setDate(start.getDate() + minimum);
      end.setDate(end.getDate() + maximum);
      return `${format.format(start)}–${format.format(end)}`;
    }

    update(variantId) {
      const variant = this.variants.find(item => String(item.id) === String(variantId));
      const country = this.dataset.country;
      const europe = ['AT','BE','BG','HR','CZ','DK','EE','FI','FR','GR','ES','NL','IE','LT','LU','LV','DE','PT','RO','SK','SI','SE','HU','IT','RU'];
      const asia = ['HK','TW','CN','SG','TH','VN','JP','KR','MY','PH'];
      let status = '';
      let origin = '';
      let days = '';

      if (country === 'US') {
        if (variant?.usLocal === true) {
          status = 'In stock locally';
          origin = 'Ships from our U.S. warehouse';
          days = '5-7';
        } else {
          status = 'Local warehouse restocking';
          origin = 'Ships from our China warehouse';
          days = variant?.usDays || '25-35';
        }
      } else if (country === 'BY') {
        status = 'Available for delivery';
        origin = 'Ships from our China warehouse';
        days = variant?.euDays || '15-25';
      } else if (country === 'CA') {
        status = 'Available for delivery';
        origin = 'Ships from our China warehouse';
        days = variant?.usDays || '25-35';
      } else if (europe.includes(country)) {
        if (variant?.euLocal === true) {
          status = 'In stock locally';
          origin = 'Ships from our European warehouse';
          days = '5-7';
        } else {
          status = 'Local warehouse restocking';
          origin = 'Ships from our China warehouse';
          days = variant?.euDays || '15-25';
        }
      } else if (asia.includes(country)) {
        status = 'Available for delivery';
        origin = 'Ships from our China warehouse';
        days = '7-20';
      } else {
        this.hidden = true;
        return;
      }

      this.querySelector('.dnaskate-delivery__status').textContent = status;
      this.querySelector('.dnaskate-delivery__origin').textContent = origin;
      this.querySelector('.dnaskate-delivery__date').textContent = `Estimated delivery: ${this.dateRange(days)}`;
      this.hidden = false;
    }
  });
}
